import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=998f7a8e&"
import script from "./ArrowButton.vue?vue&type=script&lang=js&"
export * from "./ArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=998f7a8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports